export const initialChecklistOptions = {
  background: true,
  bright: 80,
  font: 2,
  border: true,
};
